import { all } from "redux-saga/effects";
import userSaga from "./user/userSaga";
import omsSaga from "./oms/omsSaga";

export default function* rootSaga() {
  yield all([userSaga(), omsSaga()]);
}
